import { Route, Routes, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { routes } from ".";
import { setGlobalNavigate } from "../utils/navigation";
import OverallEntrypoint from "@/layouts/OverallEntrypoint";
import ProtectedRoute from "./ProtectedRoute";
import Login from "@/pages/Login";
import { PermissionEnum } from "@/utils/permissionEnum";
import Login2 from "@/pages/Login2";

export default function GranaTech() {
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return (
    <Routes>
      {/* Wrap your main app with OverallEntrypoint */}
      <Route path="/" element={<OverallEntrypoint />}>
        {routes.map(({ path, component, permissions }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute
                component={component}
                routePermissions={permissions as PermissionEnum[]}
              />
            }
          />
        ))}
      </Route>
      {/* Login route outside of OverallEntrypoint */}
      <Route path="/login" element={<Login2 />} />
      <Route path="/login2" element={<Login />} />
    </Routes>
  );
}